var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrashbin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / shape / trashbin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-/-shape-/-trashbin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,18 C15.3280029,18 16,17.3280029 16,16.5 L16,6 L16.5,6 C16.776001,6 17,5.77600098 17,5.5 L17,5 C17,4.72399902 16.776001,4.5 16.5,4.5 L13.9246826,4.5 L12.8621826,2.7281189 C12.6209717,2.32620239 12.0447693,2 11.5760193,2 L8.42459106,2 C7.95584106,2 7.37963867,2.32620239 7.13842773,2.7281189 L6.07531738,4.5 L3.5,4.5 C3.22399902,4.5 3,4.72399902 3,5 L3,5.5 C3,5.77600098 3.22399902,6 3.5,6 L4,6 L4,16.5 C4,17.3280029 4.67199707,18 5.5,18 L14.5,18 Z M12.1753235,4.5 L7.82467651,4.5 L8.36999512,3.59094238 C8.39411621,3.55078125 8.44503418,3.5166748 8.4944209,3.50463867 L8.53125,3.5 L11.4689636,3.5 C11.5275269,3.5 11.5995178,3.54074097 11.6296997,3.59094238 L12.1753235,4.5 Z M14.5,16.5 L5.5,16.5 L5.5,6 L14.5,6 L14.5,16.5 Z M12.125,15 C12.3320007,15 12.5,14.8320007 12.5,14.625 L12.5,7.875 C12.5,7.66799927 12.3320007,7.5 12.125,7.5 L11.375,7.5 C11.1679993,7.5 11,7.66799927 11,7.875 L11,14.625 C11,14.8320007 11.1679993,15 11.375,15 L12.125,15 Z M8.625,15 C8.83200073,15 9,14.8320007 9,14.625 L9,7.875 C9,7.66799927 8.83200073,7.5 8.625,7.5 L7.875,7.5 C7.66799927,7.5 7.5,7.66799927 7.5,7.875 L7.5,14.625 C7.5,14.8320007 7.66799927,15 7.875,15 L8.625,15 Z",
    id: "trashbin",
    fill: "#FF7171"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashbin);
export default __webpack_public_path__ + "static/media/icon-trashbin.36903817.svg";
export { ForwardRef as ReactComponent };